/*
 * Save-time guard for the GoodsShipment currency.
 *
 * Currency is persisted onto the first goods item's customsValue (see
 * CuDeGoodsShipmentTransformer), so it can only be saved when the first item
 * has a cost. When it can't be saved, on reload the currency falls back to the
 * destination-country default (see toForm). So a save only loses data when the
 * chosen currency DIFFERS from that default and the first item has no cost.
 *
 * Returns true when the save should be blocked. Deliberately does NOT block:
 * - the default currency (it round-trips via the country fallback, no loss)
 * - an empty/absent currency
 * `firstItemTotalValue` is undefined when there are no goods items.
 */
export const shouldBlockCurrencySave = (
  currency: string | null | undefined,
  countryDefaultCurrency: string | null | undefined,
  firstItemTotalValue: number | null | undefined,
): boolean =>
  Boolean(currency) &&
  currency !== countryDefaultCurrency &&
  firstItemTotalValue == null;
